export default __webpack_public_path__ + "static/media/franchise-expo-cebu.2539c09d.jpg";